import { useEffect, useRef, useState } from "react";
import { Input } from "@/components/ui/input";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { PAISES, ccDeIso, parseTelefono, armarTelefono } from "@/lib/phone";

// Teléfono internacional reutilizable. value = {telefono, telefono_pais, telefono_e164}.
// El país del teléfono es INDEPENDIENTE del domicilio. onChange emite el objeto listo a persistir.
export default function PhoneInput({ value, onChange, testId = "phone", defaultPais = "MX" }) {
  const inicial = parseTelefono(
    (value && (value.telefono_e164 || value.telefono)) || "",
    (value && value.telefono_pais) || defaultPais
  );
  const [pais, setPais] = useState(inicial.pais);
  const [nacional, setNacional] = useState(inicial.nacional);
  // Firma de la última emisión propia: evita re-parsear el eco (que saltaría el cursor mientras se
  // escribe). Sólo re-sincroniza cuando el value cambia por una fuente EXTERNA (ej. cargar/editar).
  const lastEmitRef = useRef((value && (value.telefono_e164 || value.telefono)) || "");

  useEffect(() => {
    const incoming = (value && (value.telefono_e164 || value.telefono)) || "";
    if (incoming === lastEmitRef.current) return; // eco de nuestra propia emisión: no tocar el input
    const p = parseTelefono(incoming, (value && value.telefono_pais) || defaultPais);
    setPais(p.pais);
    setNacional(p.nacional);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value && value.telefono, value && value.telefono_e164]);

  const emit = (p, n) => {
    const out = armarTelefono(p, n);
    lastEmitRef.current = out.telefono_e164 || out.telefono || "";
    onChange(out);
  };

  return (
    <div className="flex gap-2">
      <Select value={pais} onValueChange={(v) => { setPais(v); emit(v, nacional); }}>
        <SelectTrigger data-testid={`${testId}-pais`} className="rounded-xl w-[130px] shrink-0">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {PAISES.map((p) => (
            <SelectItem key={p.iso} value={p.iso}>
              {p.flag} +{p.cc}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Input
        data-testid={`${testId}-numero`}
        className="rounded-xl flex-1"
        inputMode="tel"
        placeholder={`+${ccDeIso(pais)} número`}
        value={nacional}
        onChange={(e) => { const n = e.target.value; setNacional(n); emit(pais, n); }}
      />
    </div>
  );
}
